"use strict";

exports.__esModule = true;
var Utils_1 = require("../utils/Utils");
var Expressions_1 = require("../core/Expressions");
var Phone = function () {
  function Phone() {}
  Phone.filter = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return "";
    if (value.length > 12) value = value.substring(0, 12);
    var slices, returnable;
    if (value.length === 10) {
      slices = Expressions_1.PhoneMask.exec(value);
    } else {
      slices = Expressions_1.PhoneMaskCell.exec(value);
    }
    returnable = "";
    if (slices[1] === undefined) return "";
    returnable += "(" + slices[1];
    if (slices[2] !== undefined) returnable += ") " + slices[2];
    if (slices[3] !== undefined) returnable += "-" + slices[3];
    return returnable;
  };
  Phone.format = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return false;
    if (value.length > 11) value = value.substring(0, 11);
    if (value.length < 11) value = Utils_1.PadWithZeroes(value, 11);
    return value.replace(Expressions_1.Phone, "($1) $2-$3");
  };
  Phone.validate = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (value === false) return false;
    return Expressions_1.Phone.test(value);
  };
  return Phone;
}();
exports.Phone = Phone;